import { QuoteSetupItems } from '@/models/cart'
import { MapElementWithSectorId } from '@/models/map'
import { QuoteReservation } from '@/models/quote'
import { Service } from '@/models/service'
import { getServiceIdFromKey } from './serviceIdKeyUtils'
import { getBoughtServicesTotal } from './timeSchedules'

// This util is necessary to keep track of
// 1) amount of services of the same group added to cart
// 2) amount of services of the same group selected on the current open spot in SelectedElementDrawer
// the end goal is to avoid surpassing the group limit and prevent overbooking
export const sumServiceGroupSelectedQuantity = ({
  groupId,
  ticketServices,
  cartReservations,
  selectedElement,
  selectedElementQuotableProducts,
}: {
  groupId: number
  ticketServices: Service[]
  cartReservations: QuoteReservation[]
  selectedElement: MapElementWithSectorId
  selectedElementQuotableProducts: QuoteSetupItems
}) => {
  const groupedServicesIds = ticketServices
    .filter((ticket) => ticket.serviceGroupId === groupId)
    .map((ticket) => ticket.serviceId)

  const cartReservationsExcludingSelectedElement = cartReservations.filter(
    (reservation) =>
      reservation.spotName !== selectedElement.name ||
      reservation.spotType !== selectedElement.subType
  )

  const aggregatedCartServiceQuantities =
    cartReservationsExcludingSelectedElement
      .map((res) => res.boughtServices)
      .reduce<Record<number, number>>((acc, boughtServicesRecord) => {
        Object.entries(boughtServicesRecord).forEach(([key, boughtService]) => {
          const serviceId = Number(key)
          acc[serviceId] =
            (acc[serviceId] ?? 0) + getBoughtServicesTotal(boughtService)
        })
        return acc
      }, {})

  const groupQuantityInCart = Object.entries(aggregatedCartServiceQuantities)
    .map(([key, value]) => {
      if (groupedServicesIds.includes(getServiceIdFromKey(key))) {
        return value
      }
      return 0
    })
    .filter((value) => value !== null)
    .reduce((acc, curr) => acc + curr, 0)

  const groupQuantityInSelectedElement = Object.entries(
    selectedElementQuotableProducts.boughtServices
  )
    .map(([key, boughtService]) => {
      if (groupedServicesIds.includes(Number(key))) {
        return getBoughtServicesTotal(boughtService)
      }
      return 0
    })
    .reduce((acc, curr) => acc + curr, 0)

  const totalGroupSelectedQuantity =
    groupQuantityInCart + groupQuantityInSelectedElement
  return totalGroupSelectedQuantity
}
